module.exports = __webpack_public_path__ + "static/red-light-6826a50bc141c1f8e0be8b7948332cd7.png";